import {Box, Divider, IconButton, Typography} from "@mui/material";
import {PageBaseModel} from "@contents/models/baseModel";
import {_PageTitleType, PageTitleType} from "@app/constants/types";

import {FlexBox} from "@contents/components/customStyledComponent";
import React, {ReactNode, useEffect} from "react";
import {ChevronLeft} from "@mui/icons-material";
import {styled} from "@mui/material/styles";
import SystemViewModel from "@contents/viewModels/systemViewModel";

const ContentLayoutWrap = styled(FlexBox)(() => ({
    flexDirection: "column",
    marginBottom: '20px'
    // gap: "20px",
}));

type ContentWrapProps = {
    $isDetail: boolean;
    borderRadius?: string;
    padding?: string;
};
const ContentWrap = styled(FlexBox)<ContentWrapProps>(
    ({ theme, $isDetail, borderRadius, padding }) => ({
        height: "100%",
        // marginBottom: "18px",
        gap: "20px",
        "& .contentBox": {
            width: "100%",
            backgroundColor: "white",
        },
    })
);

const ContentTitleWrap = styled(FlexBox)(
    ({theme}) => ({
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20px",
        borderBottom: "1px solid",
        borderColor: theme.palette.eliga_0F5.main
    })
);

const ContentTitlePageWrap = styled(FlexBox)(
    ({theme}) => ({
        flexDirection: "column",
        gap: "10px",
        "& .titleSummery": {
            borderLeft: "solid 1px #E3E6ED",
            color: theme.palette.text.secondary
        },
    }));

const ContentTitleBackWrap = styled(FlexBox)(() => ({
    alignItems: "center",
}));

const BackIconWrap = styled(IconButton)(
    ({ theme }) => ({
        padding: 0,
        backgroundColor: theme.palette.eliga_6FA.main,
        width: '34px',
        height: '34px',
        borderRadius: '8px'
    })
)

interface ContentLayoutProps extends PageBaseModel {
    titleType: _PageTitleType; // 타이틀 타입 일반 타이틀인지 백버튼이 있는 타이틀인지 구분
    title?: string; // 타이블
    backTitle?: string;
    summery?: string; // 서브 설명
    backOnClick?: () => void; // 백버튼 메소스
    rightComponent?: ReactNode; // 우측 버튼 컴포넌트
    bottomComponent?: ReactNode; // 하단 버튼 컴포넌트
    tabComponent?: ReactNode; // 탭 컴포넌트
    nestedTabComponent?: ReactNode; // 중첩 탭 컴포넌트
    children: ReactNode; // 콘텐츠
    isDetail?: boolean;
    customLayout?: boolean;// content 타입 (리스트와 상세의 패딩이 다르기 때문에 구분)
    gap?: string;
    borderRadius?: string;
    padding?: string;
}

const ContentMobileLayout = ({
                                 menuId,
                                 titleType,
                                 title,
                                 backTitle,
                                 summery,
                                 backOnClick,
                                 children,
                                 rightComponent,
                                 tabComponent,
                                 nestedTabComponent,
                                 gap = '18px',
                                 padding,
                                 borderRadius,
                                 isDetail = false,
                                 customLayout = false,
                                 bottomComponent
                             }: ContentLayoutProps) => {

    const systemViewModel = SystemViewModel();

    // router의 menuId를 받아 현제 메뉴를 인식한다.
    useEffect(() => {
        systemViewModel.setActiveRoute(menuId);
    }, [menuId]);

    // 뒤로가기
    const onBackClick = () => {
        backOnClick ? backOnClick() : history.back();
    };

    return (
        <ContentLayoutWrap>
            {/*<BreadcrumbComp menuId={menuId} />*/}
            <ContentTitleWrap>
                {titleType === PageTitleType.TITLE ? (
                    <ContentTitlePageWrap>
                        <Typography variant="h5">{title}</Typography>
                        {summery && <Typography className="titleSummery">{summery}</Typography>}
                    </ContentTitlePageWrap>
                ) : (
                    <ContentTitleBackWrap>
                        <FlexBox $column gap="20px">
                            {(title || summery) &&
                                <ContentTitlePageWrap>
                                    <Typography variant="h5">{title}</Typography>
                                    {/*<Typography className="titleSummery">{summery}</Typography>*/}
                                </ContentTitlePageWrap>
                            }
                            <FlexBox alignItems={'center'} gap="10px">
                                <BackIconWrap onClick={onBackClick}>
                                    <ChevronLeft />
                                </BackIconWrap>
                                <Typography variant="h5">{backTitle}</Typography>
                            </FlexBox>
                        </FlexBox>
                    </ContentTitleBackWrap>
                )}
                {rightComponent && <FlexBox alignItems={'flex-end'}>{rightComponent}</FlexBox>}
            </ContentTitleWrap>
            <FlexBox $column gap={gap} padding={'20px'}>
                {tabComponent && <Box>{tabComponent}</Box>}
                {nestedTabComponent && (
                    <Box marginTop="20px">{nestedTabComponent}</Box>
                )}
                <ContentWrap $isDetail={isDetail} padding={padding} borderRadius={borderRadius} $column>
                    {customLayout
                        ? children
                        : React.Children.toArray(children).map((child, index) => (
                            <Box key={index} className="contentBox">
                                {child}
                            </Box>
                        ))}
                </ContentWrap>
            </FlexBox>
            {bottomComponent &&
                <>
                    <Divider orientation="horizontal" sx={{ margin: '10px 0 30px 0'}} />
                    <FlexBox marginRight={'20px'} alignItems={'flex-end'} justifyContent={'flex-end'}>{bottomComponent}</FlexBox>
                </>
            }
        </ContentLayoutWrap>
    );
};

export default ContentMobileLayout;
